/****************************************************************IMPORTS*/
/****************************************NPM MODULES*/
import { FC } from "react";
/****************************************************/

/*****************************************INTERFACES*/
import { IMovesCount } from "../interfaces";
/****************************************************/
/************************************************************************/


/************************************************************COORDINATES*/
export const MovesCount: FC<IMovesCount> = ({ movesCount }) => {
    /*****************************************RETURN TSX*/
    return (
        <div className="count">
            <div>{movesCount}</div>
            <div>{`mouvement${movesCount > 1 ? 's' : ''}`}</div>
        </div>
    );
    /****************************************************/
};
/************************************************************************/